<template>
    <div>
        <div>
            <img src="../assets/banner/案例欣赏banner1920x280px.png">
        </div>
        <div class="margin-auto margin-top-30 flex" style="width:1200px;">
            <div class="leftMenu">
                <detailNav ref="nav" :list="nav.anlixinshang" @change="handleChange" />
            </div>
            <div class="rightConent">
                <div class="margin-bottom-30">
                    <tab :title="info.title" />
                </div>
                <div class="img">
                    <img :src="info.litpic" alt="" class="img-100">
                    <!-- <div class="title-img">{{info.title}}</div> -->
                </div>
                <div style="margin-top:30px;" class="flex introduce">
                    <div v-html="info.content">

                    </div>
                    <!-- <div class="flex-sub bg-color">
                        <div class="img1">
                            <img src="../assets/case/ico25.png" alt="">
                        </div>
                        <div class="font-16">
                            项目名称
                        </div>
                        <div class="text-gray font-14">
                            成都 · 蔚蓝卡地亚花园城
                        </div>
                    </div>
                    <div class="flex-sub ">
                        <div class="img1">
                            <img src="../assets/case/ico26.png" alt="">
                        </div>
                        <div class="font-16">
                            开发商
                        </div>
                        <div class="text-gray font-14">
                            成都蔚蓝卡地亚投资有限公司
                        </div>
                    </div >
                    <div class="flex-sub bg-color">
                        <div class="img1">
                            <img src="../assets/case/ico27.png" alt="">
                        </div>
                        <div class="font-16">
                            项目简介
                        </div>
                        <div class="text-gray font-14">
                            蔚蓝卡地亚花园城紧邻3000亩“城市绿肺”天府中央公园，由八大主题景观构建的湖滨公园及山地公园，让自然融入生活，为城市经典带来活力。
                        </div>
                    </div>
                    <div class="flex-sub ">
                        <div class="img1">
                            <img src="../assets/case/ico28.png" alt="">
                        </div>
                        <div class="font-16">
                            产品应用
                        </div>
                        <div class="text-gray font-14">
                            NFD70外开折叠门系统
                        </div>
                    </div> -->
                </div>
                <div style="margin-top:30px;">
                    <tabs title="其他案例" />

                    <notable />

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import detailNav from '../components/detailNav'
import notable from '../components/coreBusiness/notable'
import tabs from '../components/coreBusiness/tabs'
import { mapGetters, mapMutations } from 'vuex'
import { getCasedetails } from '../api/api'
import tab from '../components/tab'
export default {
    name: 'CaseDetail',
    components: {
        tabs,
        detailNav,
        notable,
        tab
    },
    computed: {
        ...mapGetters({
            nav: 'getNav'
        })
    },
    data() {
        return {
            info: {},
            index: 0
        }
    },
    methods: {
        getData(id) {
            getCasedetails({ typeid: id }).then(res => {
                //  console.log(res)
                if (res.code == 1) {

                    this.info = res.data
                }
            })
        },
        handleChange(index) {
            // this.info=this.list[index]
            this.$router.push({ path: '/Case', query: { index: index } })
        }
    },
    mounted() {
        this.index = this.$route.query.index
        // console.log(this.index)
        this.$refs.nav.setActive(this.index)
        this.getData(this.$route.query.id)
    }
}
</script>

<style lang="scss" scoped>
.rightConent {
    width: 900px;
    // width:1200px;
    padding: 0 25px;
}

.leftMenu {
    width: 200px;
    margin-right: 50px;
}

.img {
    background: #CDB499;
    width: 100%;
    height: 454px;
    position: relative;
}

.img .title-img {
    position: absolute;
    bottom: 0;
    right: 0;
    color: #fff;
    padding: 10px;
    // background:blue ;
    background: rgba(40, 40, 40, .6);
    // opacity:0.6;

}

.introduce {
    // min-height: 300px;
}

.introduce>div {
    // padding: 25px;
}

.introduce .img1+div {
    margin: 30px 0 10px 0;
    color: #27499d;
}

.bg-color {
    background: #f8f8f8;
}</style>